<app-pcbread-crumb
  [data]="'Administration,SystemSetting,Menu'"
></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <div class="row pb-2 m-0">
    <div
      class="col-sm-4 col-12 order-xxl-1 order-xs-1 order-xl-1 order-lg-1 order-md-1 order-sm-1 order-1 d-flex justify-content-sm-start align-items-sm-start justify-content-center align-items-center flex-wrap align-content-start p-0"
    >
      <h5 class="m-0 mobile-size">
        {{ "Menu" | translate }}
      </h5>
    </div>
    <div
      class="col-sm-4 col-12 order-xxl-2 order-xs-2 order-xl-2 order-lg-2 order-md-2 order-sm-2 order-3 d-flex justify-content-center align-items-center p-0"
    ></div>
    <div
      class="col-sm-4 col-12 col-sm-4 col-12 order-xxl-3 order-xs-3 order-xl-3 order-lg-3 order-md-3 order-sm-3 order-2 d-flex justify-content-end mb-2 p-0"
    ></div>
  </div>
  <div class="row">
    <div class="col-12">
      <div
        class="accordion mt-3 accordion-header-primary menu-accordion"
        id="accordionWithIcon"
      >
        <ng-container *ngFor="let grandParent of apiDataModel; let i = index">
          <div class="card accordion-item my-2">
            <h2 class="accordion-header d-flex align-items-center">
              <button
                type="button"
                class="accordion-button collapsed"
                [style]="'--background-color:'+ grandParent.color.replace('rgb(', '').replace(')', '').split(' ').join(',')"
                [style.color]="grandParent.color + ' !important'"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#accordionGrandParent-' + i"
                aria-expanded="false"
              >
                <i class="me-2" [ngClass]="grandParent.icon"></i>
                {{ grandParent.viewName | translate }}
              </button>
            </h2>

            <div
              [id]="'accordionGrandParent-' + i"
              class="accordion-collapse collapse"
              [style]="'--background-color:'+ grandParent.color.replace('rgb(', '').replace(')', '').split(' ').join(',')"
            >
              <div class="accordion-body lh-2">
                <div class="edit-box row ms-4">
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "viewName" }}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.viewName"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "Order"  }}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.order"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "icon"}}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.icon"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "color"}}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.color"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "urlField" }}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.urlField"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                    <label for="organizationname" class="form-label m-0"
                      >{{ "endPoint" }}:</label
                    >
                    <div class="validation-alert-sale-buy">
                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                    </div>
                    <input
                      id="FactorId"
                      type="text"
                      autocomplete="off"
                      class="form-control Focusable"
                      appSelectOnFocus
                      [(ngModel)]="grandParent.endPoint"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="{{ 'FactorId' | translate }}"
                    />
                      <!-- [ngClass]="{
                      'is-invalid':
                      backendJson.factorIdMessage != '' &&
                      backendJson.factorIdMessage != null
                      }" -->
                  </div>
                  <div class="button-box w-auto">
                    <button type="button" class="btn btn-icon btn-outline-primary" (click)="saveData(grandParent)">
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                
                <ng-container
                  *ngFor="let parent of grandParent.children; let j = index"
                >
                  <div class="card accordion-item my-2">
                    <h2 class="accordion-header d-flex align-items-center">
                      <button
                        type="button"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        [style.color]="parent.color + ' !important'"
                        [attr.data-bs-target]="'#accordionParent-' + j"
                        aria-expanded="false"
                      >
                        <i class="me-2" [ngClass]="parent.icon"></i>
                        {{ parent.viewName | translate }}
                      </button>
                    </h2>

                    <div
                      [id]="'accordionParent-' + j"
                      class="accordion-collapse collapse"
                    >
                      <div class="accordion-body lh-2">
                        <div class="edit-box row ms-4">
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "viewName" }}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.viewName"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "Order"  }}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.order"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "icon"}}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.icon"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "color"}}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.color"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "urlField" }}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.urlField"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                            <label for="organizationname" class="form-label m-0"
                              >{{ "endPoint" }}:</label
                            >
                            <div class="validation-alert-sale-buy">
                              <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                            </div>
                            <input
                              id="FactorId"
                              type="text"
                              autocomplete="off"
                              class="form-control Focusable"
                              appSelectOnFocus
                              [(ngModel)]="parent.endPoint"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="{{ 'FactorId' | translate }}"
                            />
                              <!-- [ngClass]="{
                              'is-invalid':
                              backendJson.factorIdMessage != '' &&
                              backendJson.factorIdMessage != null
                              }" -->
                          </div>
                          <div class="button-box w-auto">
                            <button type="button" class="btn btn-icon btn-outline-primary" (click)="saveData(parent)">
                              <i class="fa fa-save"></i>
                            </button>
                          </div>
                        </div>
                        <ng-container
                          *ngFor="let child of parent.children; let z = index"
                        >
                          <div class="card accordion-item my-2">
                            <h2
                              class="accordion-header d-flex align-items-center"
                            >
                              <button
                                type="button"
                                class="accordion-button collapsed"
                                [style.color]="child.color + ' !important'"
                                data-bs-toggle="collapse"
                                [attr.data-bs-target]="'#accordion-child-' + z"
                                aria-expanded="false"
                              >
                                <i class="me-2" [ngClass]="child.icon"></i>
                                {{ child.viewName | translate }}
                              </button>
                            </h2>

                            <div
                              [id]="'accordion-child-' + z"
                              class="accordion-collapse collapse"
                            >
                              <div class="accordion-body lh-2">
                                <div class="edit-box row ms-4">
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "viewName" }}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.viewName"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "Order"  }}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.order"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "icon"}}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.icon"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "color"}}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.color"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "urlField" }}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.urlField"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="col-12 col-lg-2 col-md-6 top-input-box mt-3">
                                    <label for="organizationname" class="form-label m-0"
                                      >{{ "endPoint" }}:</label
                                    >
                                    <div class="validation-alert-sale-buy">
                                      <!-- <p>{{ backendJson.factorIdMessage }}</p> -->
                                    </div>
                                    <input
                                      id="FactorId"
                                      type="text"
                                      autocomplete="off"
                                      class="form-control Focusable"
                                      appSelectOnFocus
                                      [(ngModel)]="child.endPoint"
                                      [ngModelOptions]="{ standalone: true }"
                                      placeholder="{{ 'FactorId' | translate }}"
                                    />
                                      <!-- [ngClass]="{
                                      'is-invalid':
                                      backendJson.factorIdMessage != '' &&
                                      backendJson.factorIdMessage != null
                                      }" -->
                                  </div>
                                  <div class="button-box w-auto">
                                    <button type="button" class="btn btn-icon btn-outline-primary" (click)="saveData(child)">
                                      <i class="fa fa-save"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- 
        <div class="card accordion-item my-2">
          <h2 class="accordion-header d-flex align-items-center">
            <button
              type="button"
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#accordionWithIcon-1"
              aria-expanded="false"
            >
              <i class="bx bx-bar-chart-alt-2 me-2"></i>
              گزینه سرتیتر 1
            </button>
          </h2>

          <div
            id="accordionWithIcon-1"
            class="accordion-collapse collapse"
            style=""
          >
            <div class="accordion-body lh-2">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
              نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی
            </div>
          </div>
        </div>

        <div class="accordion-item card">
          <h2 class="accordion-header d-flex align-items-center">
            <button
              type="button"
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#accordionWithIcon-2"
              aria-expanded="false"
            >
              <i class="bx bx-briefcase me-2"></i>
              گزینه سرتیتر 2
            </button>
          </h2>
          <div id="accordionWithIcon-2" class="accordion-collapse collapse">
            <div class="accordion-body lh-2">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
              نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.
              کتابهای
            </div>
          </div>
        </div>

        <div class="accordion-item card">
          <h2 class="accordion-header d-flex align-items-center">
            <button
              type="button"
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#accordionWithIcon-3"
              aria-expanded="false"
            >
              <i class="bx bx-gift me-2"></i>
              گزینه سرتیتر 3
            </button>
          </h2>
          <div id="accordionWithIcon-3" class="accordion-collapse collapse">
            <div class="accordion-body lh-2">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
              استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد
              نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</div>


<app-pcsuccess-modal
  [showModal]="saveChange"
  (parentAction)="saveChange=false"
>
</app-pcsuccess-modal>

